import Types from "../../constants/Types.js";
export default {
  name: 'startTime',
  objectType: Types.firmwareRelease,
  valueType: 'timestamp',
  get: (data, cxt) => {
    let time = data?.startTime;
    if (cxt?.raw) {
      return time;
    }
    if (typeof time === 'function') {
      time = time();
    } else if (time != null) {
      time = new Date(time);
    }
    return time;
  },
  set: (data, value, cxt) => {
    let val = value;
    if (value instanceof Date) {
      val = value.getTime();
    } else if (typeof value === 'function') {
      val = value()?.getTime();
    }
    return {
      ...data,
      startTime: val
    };
  },
  canSet: () => true,
  getPatch: (data, value, cxt) => {
    let val = value;
    if (value instanceof Date) {
      val = value.getTime();
    } else if (typeof value === 'function') {
      val = value()?.getTime();
    }
    return {
      path: 'startTime',
      value: val
    };
  },
  displayName: 'Start Time',
  source: {
    type: Types.apiName,
    editable: false,
    creatable: true,
    createOptions: {
      editor: 'startTime'
    }
  }
};